var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.585,
    height: 21.634,
    viewBox: "0 0 28.585 21.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45877",
    "data-name": "Group 45877",
    transform: "translate(-5094.003 2845.106)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89735",
    "data-name": "Path 89735",
    d: "M3.069.75a3.178,3.178,0,0,0-.885.214A2.3,2.3,0,0,0,.757,3.205q-.015,7.557,0,15.115a2.372,2.372,0,0,0,1.876,2.394,2.954,2.954,0,0,0,.688.058q10.979,0,21.956.005a2.481,2.481,0,0,0,2.119-1,2.378,2.378,0,0,0,.446-1.458q0-7.558,0-15.115a2.368,2.368,0,0,0-1.932-2.4A3.6,3.6,0,0,0,25.3.752Q14.2.747,3.1.75",
    transform: "translate(5094 -2845)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_380",
    "data-name": "Line 380",
    x2: 7.778,
    transform: "translate(5110.96 -2838.302)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    x2: 7.778,
    transform: "translate(5110.96 -2833.574)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    x2: 7.778,
    transform: "translate(5110.96 -2828.855)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89736",
    "data-name": "Path 89736",
    d: "M12.515,8.751A2.347,2.347,0,1,1,10.168,6.4,2.347,2.347,0,0,1,12.515,8.751Z",
    transform: "translate(5092.83 -2845.936)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89737",
    "data-name": "Path 89737",
    d: "M4.947,18.427V16.81A1.949,1.949,0,0,1,6.9,14.861h5.573a1.949,1.949,0,0,1,1.949,1.949v1.61",
    transform: "translate(5093.305 -2847.336)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.79df49d3557276bef6a6d404eae7f561.svg";
export { ForwardRef as ReactComponent };